import { render, staticRenderFns } from "./navbar-basket.vue?vue&type=template&id=d7aac348"
import script from "./navbar-basket.vue?vue&type=script&lang=ts"
export * from "./navbar-basket.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports